<div class="form-group">
    <div class="row fields-group">
        <div class="col-auto">
            <label class="input-label">{{ 'dets.predicate' | translate }}</label>
            <select class="form-control"
                    [(ngModel)]="operator"
                    (ngModelChange)="operatorValueChanged()"
                    required>
        		<option value="" default selected disabled>{{ 'Choose here' | translate }}</option>
        		<option *ngFor="let o of operators" [ngValue]="o">{{ o | translate }}</option>
      		</select>
        </div>
        <div class="col">
            <label class="input-label">{{ 'dets.predicate_value' | translate }}</label>
            <mat-form-field class="form-control" appearance="fill">
                <mat-select [(ngModel)]="selectValue" (selectionChange)="selectValueChanged($event.value)">
                    <mat-option *ngFor="let select of selections" [value]="select?.value ?? select">
                        <span [innerHTML]="select?.label ?? select"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            
            <label class="input-label mt-2">{{ 'dets.comparison_field_label' | translate }}</label>
            <search-select *ngIf="fields.length > 0"
                    (change)="onTargetFormFieldKeyChange($event)"
                    [items]="fields"
                    [selected]="sourceFormFieldKey"
                    [placeholder]="'Choose here' | translate"></search-select>

        </div>
    </div>
</div>
